var map = {
	"./modules/corporate-entity/corporate-entity.module.ngfactory": [
		"./src/app/modules/corporate-entity/corporate-entity.module.ngfactory.js",
		"modules-corporate-entity-corporate-entity-module-ngfactory"
	],
	"./modules/payer/payer.module.ngfactory": [
		"./src/app/modules/payer/payer.module.ngfactory.js",
		"modules-payer-payer-module-ngfactory"
	],
	"./modules/pharmacy/pharmacy.module.ngfactory": [
		"./src/app/modules/pharmacy/pharmacy.module.ngfactory.js",
		"modules-pharmacy-pharmacy-module-ngfactory"
	],
	"./modules/prism-environment/prism-environment.module.ngfactory": [
		"./src/app/modules/prism-environment/prism-environment.module.ngfactory.js",
		"modules-prism-environment-prism-environment-module-ngfactory"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return __webpack_require__.e(ids[1]).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;